<template>
  <div>
    <b-dropdown
      left
      size="sm"
      class="m-0"
      dropleft
      menu-class="text-decoration-none language-dropdown-menu"
      toggle-class="language-toggle-button"
    >
      <template #button-content style="background: red;">
        <img :src="selected.img" alt="" />
      </template>
      <b-dropdown-item
        v-for="option in options"
        v-bind:key="option.text"
        v-model="selected"
        class="language-dropdown-item"
        link-class="language-dropdown-item"
      >
        <img :src="option.img" alt="" @click="changeLanguage(option)" />
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "LanguageSelection",
  props: {
    locale: String
  },
  data() {
    return {
      options: [],
      selected: {
        text: "EN",
        img: "/img/flags/en.gif"
      }
    };
  },
  methods: {
    changeLanguage(option) {
      this.selected = option;
      this.$store.dispatch("changeLanguage", option.text.toLowerCase());
    }
  },
  mounted() {
    this.selected = {
      text: this.$store.getters.getLocale.toUpperCase(),
      img: `/img/flags/${this.$store.getters.getLocale.toLowerCase()}.gif`
    };

    const supportedLanguages = this.$store.getters.getGame
      ? this.$store.getters.getGame.supportedLanguages.split("|")
      : ["en"];

    this.options = supportedLanguages.map(l => {
      return {
        text: l.toUpperCase(),
        img: `/img/flags/${l.toLowerCase()}.gif`
      };
    });
  }
};
</script>
